import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { withErrorHandler } from "@lib/utils/promiseWithErrorHandler";
import { USER_ERROR_CODES } from "@lib/constants/error-codes";
import type { Customer } from "@lib/api-services/services/profile-service/types";

export const getUser = async (signOut: () => void) =>
    withErrorHandler(
        () => ClientFetchService.get<Customer>(`/api/user/get-user`),
        [
            { errorCode: USER_ERROR_CODES.CUSTOMER_GET_FAILURE, callback: signOut },
            { errorCode: USER_ERROR_CODES.HEADER_OR_POST_DATA_INVALID, callback: signOut },
        ]
    );
